/**
 * Calculation-request lifecycle stages.
 *
 * Statuses themselves are an admin-managed option list, so nothing in the app may
 * branch on a status value. Every status row carries a `stage` from this fixed
 * vocabulary, and the UI keys its behaviour off that instead.
 *
 * Mirrors App\Support\CalculationRequestStages — keep the two in step.
 */
export const CALCULATION_REQUEST_STAGES = ['draft', 'queued', 'working', 'paused', 'done', 'closed'] as const;

export type CalculationRequestStage = (typeof CALCULATION_REQUEST_STAGES)[number];

/** Settings keys whose status rows require a stage. */
export const STAGED_SETTING_KEYS = ['calculationRequestStatuses'] as const;

/** Stages that keep a request in the engineer queue. */
export const OPEN_STAGES: readonly CalculationRequestStage[] = ['queued', 'working', 'paused'];

/** Stages a request cannot move on from. */
export const TERMINAL_STAGES: readonly CalculationRequestStage[] = ['done', 'closed'];

export function isOpenStage(stage: string | null | undefined): boolean {
    return OPEN_STAGES.includes(stage as CalculationRequestStage);
}

export function isTerminalStage(stage: string | null | undefined): boolean {
    return TERMINAL_STAGES.includes(stage as CalculationRequestStage);
}
